import {SAILPOINT_TOOLTIP_DESCRIPTIONS, OIM_TOOLTIP_DESCRIPTIONS} from '../../constants/migrationConstants'

const SAILPOINT_TOOLTIPS = {
    Application: SAILPOINT_TOOLTIP_DESCRIPTIONS.APPLICATION,
    Bundle: SAILPOINT_TOOLTIP_DESCRIPTIONS.BUNDLE,
    Capability: SAILPOINT_TOOLTIP_DESCRIPTIONS.CAPABILITY,
    CertificationDefinition: SAILPOINT_TOOLTIP_DESCRIPTIONS.CERTIFICATION_DEFINITION,
    Configuration: SAILPOINT_TOOLTIP_DESCRIPTIONS.CONFIGURATION,
    CorrelationConfig: SAILPOINT_TOOLTIP_DESCRIPTIONS.CORRELATION_CONFIG,
    DatabaseVersion: SAILPOINT_TOOLTIP_DESCRIPTIONS.DATABASE_VERSION,
    Dictionary: SAILPOINT_TOOLTIP_DESCRIPTIONS.DICTIONARY,
    DynamicScope: SAILPOINT_TOOLTIP_DESCRIPTIONS.DYNAMIC_SCOPE,
    EmailTemplate: SAILPOINT_TOOLTIP_DESCRIPTIONS.EMAIL_TEMPLATE,
    Form: SAILPOINT_TOOLTIP_DESCRIPTIONS.FORM,
    GroupDefinition: SAILPOINT_TOOLTIP_DESCRIPTIONS.GROUP_DEFINITION,
    IdentityTrigger: SAILPOINT_TOOLTIP_DESCRIPTIONS.IDENTITY_TRIGGER,
    PasswordPolicy: SAILPOINT_TOOLTIP_DESCRIPTIONS.PASSWORD_POLICY,
    Policy: SAILPOINT_TOOLTIP_DESCRIPTIONS.POLICY,
    QuickLink: SAILPOINT_TOOLTIP_DESCRIPTIONS.QUICK_LINK,
    Rule: SAILPOINT_TOOLTIP_DESCRIPTIONS.RULE,
    SPRight: SAILPOINT_TOOLTIP_DESCRIPTIONS.SP_RIGHT,
    TaskDefinition: SAILPOINT_TOOLTIP_DESCRIPTIONS.TASK_DEFINITION,
    UIConfig: SAILPOINT_TOOLTIP_DESCRIPTIONS.UI_CONFIG,
    Workflow: SAILPOINT_TOOLTIP_DESCRIPTIONS.WORKFLOW,
    YAMLConfig: SAILPOINT_TOOLTIP_DESCRIPTIONS.YAML_CONFIG,
    Account: SAILPOINT_TOOLTIP_DESCRIPTIONS.ACCOUNT,
    Entitlement: SAILPOINT_TOOLTIP_DESCRIPTIONS.ENTITLEMENT,
    Identity: SAILPOINT_TOOLTIP_DESCRIPTIONS.IDENTITY,
    ObjectConfig: SAILPOINT_TOOLTIP_DESCRIPTIONS.OBJECT_CONFIG,
    Custom: SAILPOINT_TOOLTIP_DESCRIPTIONS.CUSTOM,
    Workgroup: SAILPOINT_TOOLTIP_DESCRIPTIONS.WORKGROUP,
};

const OIM_TOOLTIPS = {
    applications: OIM_TOOLTIP_DESCRIPTIONS.applications,
    accounts: OIM_TOOLTIP_DESCRIPTIONS.accounts,
    entitlements: OIM_TOOLTIP_DESCRIPTIONS.entitlements,
    identities: OIM_TOOLTIP_DESCRIPTIONS.identities,
    Application: OIM_TOOLTIP_DESCRIPTIONS.applications,
    Account: OIM_TOOLTIP_DESCRIPTIONS.Account,
    Identity: OIM_TOOLTIP_DESCRIPTIONS.Identity,
    Datasets: OIM_TOOLTIP_DESCRIPTIONS.datasets,
    EmailTemplates: OIM_TOOLTIP_DESCRIPTIONS.EmailTemplates,
    RoleMemberships: OIM_TOOLTIP_DESCRIPTIONS.RoleMemberships,
    EnterpriseRoles: SAILPOINT_TOOLTIP_DESCRIPTIONS.ENTERPRISE_ROLES,
    UserGroups: SAILPOINT_TOOLTIP_DESCRIPTIONS.USER_GROUPS,
    PasswordPolicy: SAILPOINT_TOOLTIP_DESCRIPTIONS.PASSWORD_POLICY,
    LookupDefinitions: SAILPOINT_TOOLTIP_DESCRIPTIONS.LOOKUP_DEFINITIONS,
    RequestableEntitlements: SAILPOINT_TOOLTIP_DESCRIPTIONS.REQUESTABLE_ENTITLEMENTS,
    UsersAssignedEntitlements: SAILPOINT_TOOLTIP_DESCRIPTIONS.USERS_ASSIGNED_ENTITLEMENTS,
};

const getTooltip = (objectType, sourceType) => {
  if (sourceType?.includes('oim')) {
    return OIM_TOOLTIPS[objectType] || '';
  }
  return SAILPOINT_TOOLTIPS[objectType] || '';
};

export default getTooltip;